import { render, staticRenderFns } from "./AppleLogin.vue?vue&type=template&id=dc60acc2&"
import script from "./AppleLogin.vue?vue&type=script&lang=js&"
export * from "./AppleLogin.vue?vue&type=script&lang=js&"
import style0 from "./AppleLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports